import Card from 'components/card/Card';

const ComingSoon = () => {
  return <Card textAlign="center">Coming soon...</Card>;
};

export default ComingSoon;
